import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import useU2000AxiosAuthenticated from '../u2000Core/axios/U2000UseAxiosAuthenticated';
import { U2000HandleApiError } from '../u2000Core/axios/U2000HandleApiError';
import { useToast } from '../u2000Core/context/toast/U2000ToastContext';
import type { U2000AutoCompleteSearchResult } from '../u2000Core/types/U2000AutoCompleteSearchResult';
import { u2000ExtractAutoCompleteResults } from '../u2000Core/utils/u2000ExtractAutoCompleteResults';
import {
  districtCadastreHandleApiError,
  doFindDistricts,
  type U3143AutoCompletCriterias,
  type U3143FindDistrictItem,
} from './U3143Service';
import { NS } from './U3143';

/** Recherche district via POST /U3143/findDistricts (criteriaLookup BL-0058). */
export function useU3143FindDistrictsHandlers() {
  const axios = useU2000AxiosAuthenticated();
  const { t } = useTranslation();
  const toast = useToast();

  const search = useCallback(
    async (criterias: U3143AutoCompletCriterias): Promise<U2000AutoCompleteSearchResult<U3143FindDistrictItem>> => {
      try {
        const response = await doFindDistricts(axios, criterias);
        return u2000ExtractAutoCompleteResults<U3143FindDistrictItem>(response.data);
      } catch (error: unknown) {
        const errorResult = U2000HandleApiError(error as Error, t, NS, districtCadastreHandleApiError);
        if (errorResult.genericErrors?.length) {
          errorResult.genericErrors.forEach((err) => toast.error(err.text, err.title));
        }
        return { results: [], totalCount: 0, truncated: false };
      }
    },
    [axios, t, toast],
  );

  return { search };
}
